import { render, staticRenderFns } from "./MemberStatusForm.vue?vue&type=template&id=18dcc68f&scoped=true"
import script from "./MemberStatusForm.vue?vue&type=script&lang=js"
export * from "./MemberStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dcc68f",
  null
  
)

export default component.exports